import type { RouteRecordRaw } from 'vue-router';

import LoginView from '@/services/authentication/views/LoginView.vue';
import ConfirmPasswordResetView from '@/services/authentication/views/ConfirmPasswordResetView.vue';
import LogoutView from '@/services/authentication/views/LogoutView.vue';
import AuthenticateView from '@/services/authentication/views/AuthenticateView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/login',
        name: 'login',
        components: {
            default: LoginView,
        },
        meta: {
            anonymous: true,
        },
    },
    {
        path: '/reset-password/:requestId',
        name: 'password-confirmation',
        components: {
            default: ConfirmPasswordResetView,
        },
        meta: {
            anonymous: true,
        },
    },
    {
        path: '/logout',
        name: 'logout',
        components: {
            default: LogoutView,
        },
        meta: {
            anonymous: true,
        },
    },
    {
        path: '/authenticate',
        name: 'authenticate',
        components: {
            default: AuthenticateView,
        },
        meta: {
            anonymous: true,
        },
    },
];

export default routes;
